
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'OvarianCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/DS/OvarianCancer_TNM.vue